import { render, staticRenderFns } from "./reportFeeDetailList.vue?vue&type=template&id=2002ac3f&scoped=true"
import script from "./reportFeeDetailList.vue?vue&type=script&lang=js"
export * from "./reportFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./reportFeeDetailList.vue?vue&type=style&index=0&id=2002ac3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2002ac3f",
  null
  
)

export default component.exports